// extracted by mini-css-extract-plugin
export default {"editing":"styles_editing__AQ-lt","message":"styles_message__d52TO","formInput":"styles_formInput__I+fFA"};